<template>
  <div>
    <el-card>
      <div class="table-head">
        <div>
          <el-date-picker
            style="width: 180px"
            v-model="year"
            type="year"
            placeholder="选择年"
            format="YYYY"
            value-format="YYYY"
          >
          </el-date-picker>

          <el-button class="copyBtn" type="primary" @click="modelPkgBtn"
            >复制</el-button
          >
        </div>
        <div class="btn-group">
          <el-button
            v-show="selectedPkg != ''"
            type="primary"
            @click="handleViewSeasonTotal"
            >查看综述</el-button
          >
          <el-button type="primary" @click="handleAddModelPkg"
            >添加模型库</el-button
          >

          <el-button type="primary" @click="handleAddModel"
            >添加考核模型</el-button
          >
        </div>
      </div>
      <!-- 模型库表 -->
      <el-row gutter="10">
        <el-col :span="6">
          <el-table
            :data="modelPkgData"
            border
            highlight-current-row
            style="width: 100%"
            height="700"
            ref="multipleTable1"
            :default-sort="{ prop: 'id' }"
            row-key="id"
            @row-click="selectPkg"
          >
            <template v-for="column in modelPkgTable" :key="column.label">
              <el-table-column
                :prop="column.prop"
                :label="column.label"
                sortable
              >
              </el-table-column>
            </template>
            <el-table-column label="操作" width="120">
              <template #default="scope">
                <el-button
                  size="mini"
                  @click.stop="handleEditPkg(scope.$index, scope.row)"
                  type="text"
                  >编辑</el-button
                >
                <el-popconfirm
                  title="确认删除?"
                  @confirm="handleDeletePkg(scope.$index, scope.row)"
                  confirm-button-text="是"
                  cancel-button-text="否"
                >
                  <template #reference>
                    <el-button type="text" size="mini">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <!-- 具体考核模型表 -->
        <el-col :span="18">
          <el-table
            :data="modelData"
            border
            style="width: 100%"
            height="700"
            ref="multipleTable2"
            :default-sort="{ prop: 'id' }"
            row-key="id"
          >
            <el-table-column type="selection" width="55" fixed />
            <template v-for="column in modelTable" :key="column.label">
              <el-table-column
                :prop="column.prop"
                :label="column.label"
                :formatter="formatter"
                width="180"
                sortable
              >
              </el-table-column>
            </template>
            <el-table-column label="操作" width="160">
              <template #default="scope">
                <el-button
                  size="mini"
                  @click="handleEditModel(scope.$index, scope.row)"
                  type="text"
                  >查看</el-button
                >
                <el-popconfirm
                  title="确认删除?"
                  @confirm="handleDeleteModel(scope.$index, scope.row)"
                  confirm-button-text="是"
                  cancel-button-text="否"
                >
                  <template #reference>
                    <el-button type="text" size="mini">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>

    <!-- 添加模型库 -->
    <el-dialog
      v-model="showableComp.showAddModelPkg"
      title="添加考核模型库"
      width="40%"
    >
      <el-form>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="模型库名称">
              <el-input v-model="newPkg.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="季度">
              <SeasonSelect
                v-model="newPkg.period"
                @season="this.newPkg.period = $event"
              ></SeasonSelect>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="12"> </el-col>
        <el-col :span="12"> </el-col>
        <el-row>
          <el-col :span="24" class="btn-group">
            <el-form-item>
              <el-button type="primary" @click="submitModelPkg">确定</el-button>
              <el-button @click="doCancel">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 添加模型 -->
    <el-dialog
      v-model="showableComp.showAddModel"
      title="添加考核模型"
      width="70%"
    >
      <el-form :model="addModelForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="考核方式名称">
              <el-input v-model="newModel.modelName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="指标类型">
              <NormSelect
                v-model="newModel.normId"
                @modelType="this.newModel.normId = $event"
              ></NormSelect>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="考核对象">
              <RoleSelect
                v-model="newModel.object"
                @role="this.newModel.object = $event"
                placeMsg="请选择考核对象，即被打分者"
              ></RoleSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考核主体">
              <RoleSelect
                v-model="newModel.subject"
                @role="this.newModel.subject = $event"
                placeMsg="请选择考核对象，即打分者"
                allowMultiple="true"
              ></RoleSelect>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="考核对象类型">
              <el-select
                v-model="newModel.objectType"
                placeholder="请选择评价方式"
              >
                <el-option
                  v-for="(item, key) in objectTypeArr"
                  :key="key"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评分占比(%)">
              <el-input
                disabled
                v-model="newModel.proportion"
                placeholder="评分占比，即该指标在考核对象的所有考核指标中所占比例"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="考核周期">
              <SeasonSelect
                v-model="newModel.season"
                @season="this.newModel.season = $event"
              ></SeasonSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否启用">
              <div class="radio-group">
                <el-radio v-model="newModel.available" label="1">启用</el-radio>
                <el-radio v-model="newModel.available" label="0">禁用</el-radio>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="btn-group">
            <el-form-item>
              <el-button type="primary" @click="generateEvaModel"
                >生成</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider></el-divider>

      <el-table
        class="tabel2-group"
        :data="newModel.subjectModelList"
        style="width: 80%; margin: 0 auto"
        @row-dblclick="rowDoubleClick"
        v-show="showableComp.showModelSubject"
        ref="table2"
      >
        <el-table-column prop="id" label="序号" width="200"></el-table-column>
        <el-table-column prop="subjectId" label="考核主体" width="200">
          <template #default="scope">
            <RoleSelect
              v-model="scope.row.subjectId"
              @role="this.newModel.object = $event"
              disabled
            ></RoleSelect>
            <!-- <span v-else>{{ scope.row.subjectName }}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="evaType" label="考核形式" width="200">
          <template #default="scope">
            <EvaTypeSelect
              v-if="scope.row.isOk"
              v-model="scope.row.evaType"
            ></EvaTypeSelect>
            <span v-else>{{ scope.row.evaType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="proportion" label="占比(%)" width="200">
          <template #default="scope">
            <el-input
              v-if="scope.row.isOk"
              v-model="scope.row.proportion"
              style="width: 100%; hight: 100%"
            ></el-input>
            <span v-else>{{ scope.row.proportion }}</span>
          </template>
        </el-table-column>
      </el-table>

      <p class="tips">*双击表格中的数据行可以对生成的数据进行修改</p>

      <el-row>
        <el-col :span="24" class="btn-group">
          <el-form-item>
            <el-button
              type="primary"
              @click="addEvaModel"
              :disabled="disable.addModelBtn"
              >确认添加</el-button
            >
            <el-button type="message" @click="onCancel">取消</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 查看编辑本季度各项考核指标及比例 -->
    <el-dialog
      v-model="showableComp.showSeasonNorm"
      :title="selectedPkg.name + '综合考核情况'"
      width="40%"
    >
      <div class="form-btn">
        <el-button @click="handleAddOverview" type="primary">添加</el-button>
      </div>

      <el-table
        :data="evaOverView"
        style="width: 100%"
        ref="multipleTable3"
        @selection-change="handleSelectionChange"
        row-key="id"
      >
        <el-table-column label="序号" type="index" width="55" fixed />
        <el-table-column label="指标类型" prop="normType">
          <template #default="scope">
            <NormSelectV2
              v-model="scope.row.normType"
              @normType="scope.row.normType = $event"
            ></NormSelectV2>
          </template>
        </el-table-column>
        <el-table-column label="所占比例(%)" prop="proportion">
          <template #default="scope">
            <el-input v-model="scope.row.proportion"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="proportion">
          <template #default="scope">
            <el-popconfirm
              title="确认删除?"
              @confirm="deleteOverview(scope.$index, scope.row)"
              confirm-button-text="是"
              cancel-button-text="否"
            >
              <template #reference>
                <el-button type="text" size="mini">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div class="form-btn">
        <el-button type="primary" @click="saveNormOverView">保存</el-button>
        <el-button @click="cancelNormOverView">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import EvaModel from "../api/EvaModel";
export default EvaModel;
</script>

<style scoped lang="scss">
.table-head {
  display: flex;
  justify-content: space-between;
}
.btn-group {
  display: flex;
  justify-content: end;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.radio-group {
  display: flex;
  justify-content: start;
}

.form-btn {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

.el-divider {
  margin-top: 5px;
}

.tabel2-group {
  text-align: start;
}

.tips {
  text-align: left;
}

.copyBtn {
  margin-left: 10px;
}
</style>